import React from 'react';
import { useReveal } from '../lib/useReveal';
const PRODUCT_IMG = 'https://cdn.magicpatterns.com/uploads/ePWMAKd5A3Sji1M8ra4zX7/ChatGPT_Image_15_abr_2026,_12_15_19.png';
const BG_IMG = 'https://cdn.magicpatterns.com/uploads/w6mTwbYbwCmavTPC8PetFK/heylloyd-image-1774029715790.png';
export function HeroSection() {
  const [ref1, vis1] = useReveal();
  return <section className="min-h-screen pt-16 pb-6 md:pt-20 md:pb-10 px-4 sm:px-6 overflow-hidden relative flex flex-col justify-center" data-id="element-172">
      {/* Background image */}
      <div className="absolute inset-0 bg-cover bg-center bg-no-repeat" style={{
      backgroundImage: `url(${BG_IMG})`
    }} data-id="element-173"></div>
      <div className="absolute inset-0 bg-black/45" data-id="element-174"></div>

      <div ref={ref1} className={`reveal container mx-auto max-w-4xl text-center relative z-10 ${vis1 ? 'is-visible' : ''}`} data-id="element-175">
        <div className="mb-2" data-id="element-176">
          <span className="text-[#eab308] text-xs md:text-sm font-bold tracking-[0.2em] uppercase" data-id="element-177">
            ⭐ ACADEMIA HOLÍSTICA ARGENTINA ⭐
          </span>
        </div>

        <h1 className="mb-2 font-serif font-bold tracking-tight leading-none text-white" data-id="element-178">
          <span className="block text-3xl sm:text-4xl md:text-5xl lg:text-6xl mb-2" data-id="element-179">
            MEGAPACK BIODESCODIFICACIÓN INTEGRAL
          </span>
        </h1>

        <p className="text-gray-300 mb-2 max-w-3xl mx-auto leading-relaxed px-2 text-base md:text-xl font-medium" data-id="element-180">
          Tu sistema completo de biodescodificación. Desde hoy.
        </p>

        <p className="font-serif font-bold text-xl sm:text-2xl md:text-3xl tracking-wide mb-3 text-transparent bg-clip-text bg-gradient-to-r from-[#b8860b] via-[#e8c44a] to-[#b8860b]" data-id="element-181">
          Síntoma · Conflicto · Sanación — El método completo
        </p>

        {/* Product Image */}
        <div className="block mx-auto max-w-[200px] sm:max-w-xs md:max-w-sm mb-4" data-id="element-182">
          <div className="relative animate-float" data-id="element-183">
            <img src={PRODUCT_IMG} alt="MegaPack Biodescodificación Integral" className="w-full object-contain block drop-shadow-[0_12px_40px_rgba(184,134,11,0.3)]" data-id="element-184" />
          </div>
        </div>

        {/* Pill Badges */}
        <div className="flex flex-wrap justify-center gap-2 sm:gap-3 mb-3" data-id="element-185">
          <span className="flex items-center gap-2 text-xs md:text-sm text-gray-200 font-medium bg-white/5 border border-white/15 rounded-full px-3 py-1 backdrop-blur-sm" data-id="element-186">
            📄 100% PDF
          </span>
          <span className="flex items-center gap-2 text-xs md:text-sm text-gray-200 font-medium bg-white/5 border border-white/15 rounded-full px-3 py-1 backdrop-blur-sm" data-id="element-187">
            ⚡ Acceso en 5 min
          </span>
          <span className="flex items-center gap-2 text-xs md:text-sm text-gray-200 font-medium bg-white/5 border border-white/15 rounded-full px-3 py-1 backdrop-blur-sm" data-id="element-188">
            🇦🇷 Argentina
          </span>
        </div>

        {/* CTA */}
        <div className="flex flex-col items-center gap-1.5 w-full max-w-xl mx-auto mb-6" data-id="element-189">
          <a href="#premium" className="w-full block px-4 sm:px-6 py-4 md:py-5 rounded-xl text-[#0f0f1a] font-bold text-sm sm:text-base md:text-lg tracking-wider sm:tracking-widest uppercase transition-all shadow-[0_0_30px_rgba(234,179,8,0.4)] hover:shadow-[0_0_40px_rgba(234,179,8,0.6)] hover:-translate-y-1 bg-[#eab308] hover:bg-[#d4a017] border border-[#eab308]/50 text-center" style={{
          fontFamily: "'Inter', sans-serif"
        }} data-id="element-190">
            → QUIERO MI MEGAPACK AHORA
          </a>
          <p className="text-gray-400 text-xs md:text-sm font-medium mt-1" data-id="element-191">
            🛡️ Garantía 7 días | 🔒 Pago seguro | 💳 Mercado Pago
          </p>
        </div>

        {/* Social Proof Bar */}
        <div className="flex flex-wrap justify-center items-center gap-x-4 gap-y-2 text-xs sm:text-sm text-gray-300 font-medium border-t border-white/10 pt-4" data-id="element-192">
          <span data-id="element-193">+500 personas ya lo tienen</span>
          <span className="hidden sm:inline text-gray-600" data-id="element-194">•</span>
          <span data-id="element-195">6 Tomos completos</span>
          <span className="hidden sm:inline text-gray-600" data-id="element-196">•</span>
          <span data-id="element-197">6 Bonos incluidos</span>
          <span className="hidden sm:inline text-gray-600" data-id="element-198">•</span>
          <span data-id="element-199">4.9/5 calificación ⭐</span>
        </div>
      </div>
    </section>;
}